export const shouldIncludeRelationForNewTaskSync = (taskId: number, relationTaskIdFrom: number): boolean => {
  return taskId === -1 && (relationTaskIdFrom === -1 || relationTaskIdFrom === 0);
};

export const mapRelationSourceIdForTaskSync = (relationTaskIdFrom: number, sourceTaskId?: number): number => {
  return sourceTaskId === -1 && relationTaskIdFrom === -1 ? 0 : relationTaskIdFrom;
};
